import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container, FormControlLabel, Switch } from '@mui/material';
import { QueuePlayNext, DeleteForever } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import Dropzone from 'react-dropzone';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import SimpleSelect from '../../components/select/simple';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import SimpleCheckBox from '../../components/checkbox/check';
import * as Service from '../../services/organizationsla.service';
import SlaPriorityConfig from '../../components/sla-priority-config';
import { sync as syncSlaPriority } from '../../services/sla-priority.service';
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple-create';
import { browserHistory } from '../../helpers/history';
import { FormattedMessage,injectIntl } from 'react-intl';
import Title from '../../components/title-name';
import SimpleHelp from '../../components/help';
import { PapiroConsole } from '../../utils/papiroConsole';

class OrganizationSlaRegistration extends Component {

  constructor(props) {
    super(props);

    const { userSession, organizations } = this.props;
    this.globalAdm = false;
    this.isClient = true;

    this.fromProps = false
    if(this.props && this.props.location && this.props.location.state && this.props.location.state.from && this.props.location.state.from.length > 0)
      this.fromProps = true

    if(userSession.user.userrole == null){
      Api.logoff();
    }
    userSession.user.userrole.map((item, key) => {
            if(item.role.roletype !=3){
                this.isClient = false;
            }
            if(item.role.roletype ==0){
              this.globalAdm =true;
            }
        }
    );

 
    this.initialState = {
      createdUser: userSession.user.id,
      createdAt: moment().format('YYYY/MM/DD HH:mm:ss'),
      OrganizationId:  0,
      OrganizationText: '',
      DistributionStrategyId:  0,
      DistributionStrategyText: '',
      WorkHourId:  0,
      WorkHourText: '',
      name : '', 
      comments : '', 
      servicetime : '', 
      solutiontime : '', 
      SLA : '',
      saveToAllOrganizationsInGroup: false,
      useprioritysla: false,
     };

    this.state = {
      item: this.initialState,
      organizations: organizations,
      files: [],
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      OrganizationList: [],
      DistributionStrategyList: [],
      WorkHourList: [],
      SLAList: [],
      template: false,
      slaPriorityItems: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload") {
        this.componentDidMount();
    }
  }

  componentDidMount() {
    if (this.fromProps && this.state.organizations && this.state.organizations.organization && this.state.organizations.organization.id) {
      PapiroConsole.log("entrei aqui")
      this.getOrganizationsById(this.state.organizations.organization.id);
    }
    else {
      PapiroConsole.log("entrei aqui 2")
        this.getOrganizations();
    }
    this.getDistributionStrategies();
    this.getSLA();
  };
     async getSLA(){

      PapiroConsole.log("result aqui ")
      this.setState({ loading: true });
      var result = await Service.getSLA();
      PapiroConsole.log("result aqui ")
      PapiroConsole.log(result)
        if (result.success) {
          this.setState({ loading: false, SLAList: result.data });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({id:"process.error"})
          });
          Api.kickoff(result);  
        }
};

     async getOrganizations(){
          this.setState({ loading: true });
          var result = await Service.getOrganizations();
            if (result.success) {
              this.setState({ loading: false, OrganizationList: result.data });
                            
            } else {
              const intl = this.props.intl;
              this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({id:"process.error"})
              });
              Api.kickoff(result);  
            }
  };
  
  getOrganizationsById = async (id) => {
    this.setState({ loading: true });
    var result = await Service.getOrganizationsByIdLight(id);
    if (result.success) {
        this.setState({ loading: false, OrganizationList: [result.data] });
        await this.updateOrganization(id);
    } else {
        const intl = this.props.intl;

        this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });

        Api.kickoff(result);
    }
  };

  updateOrganization = async (id) => {
    await this.getWorkHours(id)
  }

  async getDistributionStrategies(){
          this.setState({ loading: true });
          var result = await Service.getDistributionStrategies();
            if (result.success) {
              this.setState({ loading: false, DistributionStrategyList: result.data });
                            
            } else {
              const intl = this.props.intl;
              this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({id:"process.error"})
              });
              Api.kickoff(result);  
            }
  };     async getWorkHours(orgId = 0){
          this.setState({ loading: true });
          var result = await Service.getWorkHours(orgId);
            if (result.success) {
              this.setState({ loading: false, WorkHourList: result.data });
              PapiroConsole.log("pegar expediente de sla")
              PapiroConsole.log(result)
                            
            } else {
              const intl = this.props.intl;
              this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({id:"process.error"})
              });
              Api.kickoff(result);  
            }
  };

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    if(name === 'servicetime' || name === 'solutiontime'){
      const re = /^[0-9\b]+$/;
      if(re.test(value)){
          this.setState(prevState => ({
            item: {
              ...prevState.item,
              [name]: value
            }
          }));
      }

    } else {
      this.setState(prevState => ({
        item: {
          ...prevState.item,
          [name]: value
        }
      }));

    }

  };

  handleSubmit = async e => {
    e.preventDefault();
    const intl = this.props.intl;

    this.setState({ loading: true });

    if (this.state.item.WorkHourId == 0 || this.state.item.WorkHourId == null || typeof this.state.item.WorkHourId === 'undefined' || (this.state.item.WorkHourId != null && this.state.item.WorkHourId.id != null && this.state.item.WorkHourId.id == 0)) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({id:"workhour.sla.required.message"})
      });
      return false;
    } else {

    let data = new FormData();


      if (this.isClient) {
        this.setState(prevState => ({
          item: {
            ...prevState.item,
          }
        }));
      } else {
        this.setState(prevState => ({
          item: {
            ...prevState.item,
          }
        }));
      }


      for (let key in this.state.item) {

        if (key.toString().toLowerCase().indexOf('_date') > -1 || key.toString().toLowerCase().indexOf('date_') > -1) {
          data.append(key, moment(this.state.item[key]).format('YYYY/MM/DD HH:mm:ss'));
        } else if(key.toString().toLowerCase().indexOf('sla') > -1 && this.state.template){
            var slaids = "";
            if (!this.state.item.SLA) {
              this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({id:"sla.required.message"}),
                item: this.initialState
              });
              return;
            }
            this.state.item.SLA.forEach(element => {
              slaids = slaids+element.id+",";
            });
            slaids = slaids.slice(0, -1);
            // console.log(key)
            // console.log(slaids)
            data.append(key, slaids);
        }else{
          data.append(key, this.state.item[key].id ? this.state.item[key].id : this.state.item[key]);
        }
      }

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

        Api.post('/organizationslas', data, config)

        .then(async result => {
          if (result.data.success) {
            const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'success',
              notificationMessage: intl.formatMessage({id:"add.success"}),
              item: this.initialState,
              files: []
            });
            if (this.state.item.useprioritysla && this.state.slaPriorityItems && this.state.slaPriorityItems.length > 0) {
              const newId = result.data.data ? result.data.data.id : null;
              const orgId = result.data.data ? (result.data.data.organizationid || result.data.data.organization_id || null) : null;
              if (newId) {
                await syncSlaPriority({
                  slaMode: 2,
                  parentId: newId,
                  organizationId: orgId,
                  items: this.state.slaPriorityItems.map(i => ({
                    priorityId: i.priorityid,
                    serviceTime: i.servicetime,
                    solutionTime: i.solutiontime,
                  })),
                });
              }
            }
            this.getOrganizations();
            this.getDistributionStrategies();
            this.getWorkHours();

          }
          else{
            const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({id:"process.error"})

            });
            Api.kickoff(result);
          }

        })
        .catch(err => {
          if(err.response && err.response.data && err.response.data.errors){
            const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
            });
          }
          else{
            const intl = this.props.intl;
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})+err.response.data
            });
          }
          Api.kickoff(err);
        });
      }
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }

  changeValues(stateName, value, text = '') {
    this.setState({ loading: true });

    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: value
      }
    }));        
    
    if(stateName === 'OrganizationId'){
      this.setState(prevState => ({
        item: {
          ...prevState.item,
          ['OrganizationText']: text,
        }
      }));
      this.getWorkHours(value.id);
    }
    if(stateName === 'DistributionStrategyId'){
      this.setState(prevState => ({
        item: {
          ...prevState.item,
          ['DistributionStrategyText']: text,
        }
      }));
    }
    if(stateName === 'WorkHourId'){
      this.setState(prevState => ({
        item: {
          ...prevState.item,
          ['WorkHourText']: text,
        }
      }));
    }
 
    this.setState({ loading: false });

  };

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }
    render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const { item } = this.state;
    const intl = this.props.intl;

    PapiroConsole.log("render")

    PapiroConsole.log(this.state)

    if(Api == null) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/unavailable`
    }

     return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='md'>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                    <Button variant='outlined' color='primary'  onClick={() => {
                      this.fromProps ? this.props.history.push(`/${this.props.match.params.lang}/organization-edit`, { organizations: this.props.organizations, propTab: 6 }) : browserHistory.goBack()}
                    }>{<FormattedMessage id="back" />}</Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
                {<FormattedMessage id="add.item" />}
                <Title />
              </Typography>
              <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                    <Grid container spacing={2}>
                    <Grid item xs={11} sm={11}>
                      <SimpleAutoComplete label={intl.formatMessage({id:"organization"})} options={this.state.OrganizationList} stateName='OrganizationId' changeSelect={this.changeValues} selected={item.OrganizationId} required />
                    </Grid>
                    <Grid item xs={11} sm={11}>
                      <SimpleCheckBox label={intl.formatMessage({id:"organization.sla.inform.sla"})} name='template' stateName='template' 
                      changeSelect={(event, newValue) => {
                        this.setState({
                          template: newValue
                        });
                      }}/>
                    </Grid>
                  {this.state.template && (
                    <Grid item xs={11} sm={11}>
                      <SimpleAutoCompleteMultiple label='SLA(s):' options={this.state.SLAList} stateName='SLA' changeSelect={this.changeValues} />
                  </Grid> 
                  ) }
                    <Grid item xs={11} sm={11} style={{display: 'none'}}>
                      <SimpleSelect label={intl.formatMessage({id:"menu.distributionstrategies"})} options={this.state.DistributionStrategyList} stateName='DistributionStrategyId' changeSelect={this.changeValues} selected={item.DistributionStrategyId} />
                    </Grid>
                    <Grid item xs={11} sm={11}>
                      <SimpleSelect label={intl.formatMessage({id:"workhour.Sla"})} options={this.state.WorkHourList} stateName='WorkHourId' changeSelect={this.changeValues} selected={item.WorkHourId} />
                    </Grid>
                    <Grid item xs={1} sm={1}>
                      <SimpleHelp message={this.props.intl.formatMessage({id:"organization.sla.edit.sla.calculation.base.standard.values"})}/>
                    </Grid>
                {!this.state.template && (
                    <Grid item xs={11} sm={11}>
                      <TextField fullWidth inputProps={{ maxLength: 255 }} label={intl.formatMessage({id:"name"})} autoComplete='fname' variant='outlined' name='name' onChange={this.handleInputChange} value={item.name} required />
                </Grid>
                )}
                    <Grid item xs={11} sm={11}>
                      <TextField multiline rows="5" inputProps={{ maxLength: 255 }} fullWidth label={intl.formatMessage({id:"comment"})} autoComplete='fname' variant='outlined' name='comments' onChange={this.handleInputChange} value={item.comments} />
                    </Grid>
                {!this.state.template && (
                    <Grid item xs={11} sm={11}>
                      <TextField fullWidth inputProps={{ maxLength: 15 }} label={intl.formatMessage({id:"organization.category.service.sla"}) + " " + intl.formatMessage({id:"in.minutes"})} autoComplete='fname' variant='outlined' name='servicetime' onChange={this.handleInputChange} value={item.servicetime} required />
                    </Grid>)}
                {!this.state.template && (
                    <Grid item xs={1} sm={1}>
                      <SimpleHelp message={this.props.intl.formatMessage({id:"organization.sla.edit.minutes.for.called.start"})}/>
                    </Grid>)}
                {!this.state.template && (
                    <Grid item xs={11} sm={11}>
                      <TextField fullWidth inputProps={{ maxLength: 15 }} label={intl.formatMessage({id:"sla.solution"}) + " " + intl.formatMessage({id:"in.minutes"})} autoComplete='fname' variant='outlined' name='solutiontime' onChange={this.handleInputChange} value={item.solutiontime} required />
                    </Grid>)}
                {!this.state.template && (
                    <Grid item xs={1} sm={1}>
                      <SimpleHelp message={this.props.intl.formatMessage({id:"organization.sla.edit.minutes.for.called.solution"})}/>
                    </Grid>)}
                {!this.state.template && (
                  <Grid item xs={12} sm={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={item.useprioritysla || false}
                          onChange={e => this.setState(prevState => ({ item: { ...prevState.item, useprioritysla: e.target.checked } }))}
                          color="primary"
                        />
                      }
                      label={intl.formatMessage({ id: 'sla.use.priority', defaultMessage: 'Usar SLA por Prioridade' })}
                    />
                  </Grid>
                )}
                {!this.state.template && item.useprioritysla && (
                  <Grid item xs={12} sm={12}>
                    <SlaPriorityConfig
                      slaMode={2}
                      defaultServiceTime={item.servicetime}
                      defaultSolutionTime={item.solutiontime}
                      onItemsChange={(items) => this.setState({ slaPriorityItems: items })}
                    />
                  </Grid>
                )}
                  <Grid item xs={11} sm={11}>
                    <SimpleCheckBox
                    label={intl.formatMessage({id:"save.to.all.organizations.in.group"})}
                    name='saveToAllOrganizationsInGroup'
                    stateName='saveToAllOrganizationsInGroup' 
                    changeSelect={this.changeValues}
                    selected={item.saveToAllOrganizationsInGroup} />
                  </Grid>
                  <Grid item xs={11} sm={11}>
                    <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }} >
                      <Grid item xs={12} sm={4} style={{ justifyContent: 'flex-end' }} >
                        <Button 
                          type='submit'
                          fullWidth
                          variant='contained'
                          color='primary'
                          className={classes.submit} >
                          {<FormattedMessage id="save" />}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
      </div>
    );
  }
}
OrganizationSlaRegistration.propTypes = {
                    classes: PropTypes.object.isRequired
                };
                const mapStateToProps = state => ({
                  actionsHeaderMenu: state.actionsHeaderMenu,
                    headerMenu: state.headerMenu,
                    userSession: state.userSession,
                    organizations: state.organizations
                });
            export default injectIntl(connect(mapStateToProps)(withStyles(Styles)(OrganizationSlaRegistration)));
